import { ref, onMounted, getCurrentInstance } from "vue";
import { LD_FLAG_IDEA_MDP_429 } from "@components/constants/launchDarklyFlagKeys";

/** Resolves idea-MDP-429 (Fair Pay MVP) for the ⋮ More actions menus. Off until the flag resolves true. */
export function useFairPayMoreActionsFlag() {
  const { proxy } = getCurrentInstance() || {};
  const enabled = ref(false);

  onMounted(async () => {
    try {
      enabled.value = (await proxy?.$getFlag?.(LD_FLAG_IDEA_MDP_429, false)) === true;
    } catch {
      enabled.value = false;
    }
  });

  return enabled;
}
